import * as React from 'react';

import { Toggle, toggleVariants } from './components/ui/toggle.js';

export { toggleVariants }; // eslint-disable-line react-refresh/only-export-components

export function DimeToggle({ ...props }: Readonly<React.ComponentProps<typeof Toggle>>) {
  return <Toggle {...props} />;
}

DimeToggle.displayName = 'DimeToggle';
